import React from "react"
import {
  Currencies,
  getOrganization,
  saveOrganization,
  validateTextState,
  VALIDATION_TYPE
} from "../../lib/utils"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import FormControlInlineSelect from "../fragments/FormControl.Inline.Select"
import ProcessesStatus from "../fragments/ProcessesStatus"
import SimpleForm from "../fragments/SimpleForm"

class BaseCurrency extends React.Component {

  state = {
    running: false,
    success: false,
    error: null,
    organization: null,
    currencyCode: '',
    currencyCodeValidationState: VALIDATION_TYPE.NULL,
  }

  componentDidMount() {
    this.loadOrganization()
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutId)
  }

  loadOrganization = () => {

    const organization = getOrganization()
    if(!organization) return

    const { currencyCode } = this.state
    blockingFetchService(
      accessToken => apiServerApi.getOrganizationById(accessToken, organization.id),
      organization => this.setState({
        organization,
        currencyCode: organization.defaultCurrencyCode,
        currencyCodeValidationState: validateTextState(currencyCode, true),
      }),
      error => this.setState({ error: error.text }),
      _ => {}
    )
  }

  currencyCodeChanged = currencyCode => this.setState({
    currencyCode,
    currencyCodeValidationState: validateTextState(currencyCode, false),
    error: null,
  })

  saveClicked = () => {

    const { currencyCode } = this.state
    if(!currencyCode) {
      this.setState({ error: "Please choose a currency" })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null
    })

    blockingFetchService(
      accessToken => apiServerApi.updateDefaultCurrency(accessToken, currencyCode),
      organization => {

        this.setState({ 
          organization,
          success: true,
          currencyCode: organization.defaultCurrencyCode,
        })
        saveOrganization(organization)
        this.timeOutId = setTimeout(() => this.setState({ success: false }), 3000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderContent = () => {
    const { currencyCode, running, success, error, currencyCodeValidationState } = this.state
    return (
      <SimpleForm onSave={ this.saveClicked } running={ running }>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <FormControlInlineSelect
          controlId='currencyCode' validationState={ currencyCodeValidationState }
          label='Base currency' value={ currencyCode } 
          onChange={ this.currencyCodeChanged }
          options={ Currencies }
          helpText='Note: This currency will be used as base to record Journal entries'
          withEmptyOption={ true }
        />
      </SimpleForm>
    )
  }

  render() {
    return <div>
      <CustomBreadCrumb activeText='Base currency' data={ [{ url: '/settings', title: 'Settings' }] } />
      { this.renderContent() }
    </div>
  }
}

export default BaseCurrency



// WEBPACK FOOTER //
// ./src/components/Settings/BaseCurrency.js